module.exports = __webpack_public_path__ + "img/img_guang@2x.795b7def.png";